import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { ErrorService } from '../../error.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { NgZone } from '@angular/core';
import { ColumnChangeBO, saveLovBO } from './lov.model';

@Injectable({
  providedIn: 'root'
})

export class LovService {
  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    })
  };
  constructor(private http: HttpClient, public errorService: ErrorService, public toastrService: ToastrService, public zone: NgZone) { }

  SaveOrUpdateLov(saveLov: saveLovBO): Observable<any> {
    let url = "api/LOV/SaveLov";
    return this.http.post(url, saveLov, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  DeleteLov(LovId: any): Observable<any> {
    let url = "api/LOV/DeleteLov/" + LovId;
    return this.http.delete(url, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  ListDropDown(): Observable<any> {
    let url = "api/List/GetListDropDown";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  ////////===========================Column change func==================///
  getcolumwidth(): Observable<any> {

    let url = "api/ColumnChange/getwidth?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  savecolumwidth(list: ColumnChangeBO): Observable<any> {
    let url = "api/ColumnChange/Savewidth?";
    return this.http.post<any>(url, list, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
}